var map = {
	"./bg.png": "67UI",
	"./cn.png": "fcJP",
	"./cs.png": "+eum",
	"./de.png": "5IkD",
	"./dk.png": "h7fe",
	"./en.png": "1hXD",
	"./es.png": "JVlh",
	"./fn.png": "18Sb",
	"./fr.png": "IXbZ",
	"./hu.png": "T5BJ",
	"./it.png": "6dZJ",
	"./ko.png": "LAv+",
	"./no.png": "HVH8",
	"./pl.png": "uf3K",
	"./pt.png": "W1w9",
	"./ru.png": "GN1g",
	"./sv.png": "pGDn",
	"./tr.png": "y+3o",
	"./vi.png": "Lgz4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YfRD";